import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_SCC_API } from '@/service'
const api = {
  getImGroupByUid: `${utils.hostname(
    'ktalk'
  )}/ktalk-web/groupChat/queryGroupInfoForPersonal.do`,
  addImGroup: `${utils.hostname('ktalk')}/ktalk-web/groupChat/joinGroup.do`,
  queryWorkerIm: `${PREFIX_SCC_API}fchild/maternity/queryWorkerIm.do`,
  queryWorkerIm4NewSelfOpsSign: `${PREFIX_SCC_API}fchild/maternity/querySelfWorkerIm.do`
}
const SIGN_TYPE_NEW_SELF_OPS = 2

export default {
  async getImGroupByUid({ commit }, { uid, fromUserId }) {
    try {
      const param = {
        queryGroupChatInfoRequestVo: {
          empUid: uid /* 员工uid */,
          fromUserId /* (String)userId,后台进行此userId的skey对应性验证 */
        }
      }
      const res = await fetch(api.getImGroupByUid, {
        credentials: 'include',
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
      })
      const infoJSON = await res.json()
      return infoJSON
    } catch (e) {
      console.log(e)
    }
  },
  async addImGroup({ commit }, { groupId, uid }) {
    try {
      const param = {
        joinGroupRequestVo: {
          businessKey: groupId,
          joinWay: 2,
          fromUserId: '',
          parter: {
            uid,
            userIdentity: 0
          }
        }
      }
      const res = await fetch(api.addImGroup, {
        credentials: 'include',
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  },
  async queryWorkerIm({ commit }, payload) {
    try {
      let api_url =
        payload.signType == SIGN_TYPE_NEW_SELF_OPS
          ? api.queryWorkerIm4NewSelfOpsSign
          : api.queryWorkerIm
      const res = await fetch(api_url, {
        credentials: 'include',
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: queryString.stringify(payload)
      })
      const json = await res.json()
      return json
    } catch (e) {
      console.log(e)
    }
  }
}
